/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { useReducer } from "react";
import "./style.css";

export const FreeTrialButton = ({ property1, className, divClassName, vectorClassName }) => {
  const [state, dispatch] = useReducer(reducer, {
    property1: property1 || "default",
  });

  return (
    <div
      className={`free-trial-button property-1-0-${state.property1} ${className}`}
      onMouseLeave={() => {
        dispatch("mouse_leave");
      }}
      onMouseEnter={() => {
        dispatch("mouse_enter");
      }}
    >
      <div className={`text-wrapper-24 ${divClassName}`}>Free Trial</div>
      <img
        className={`vector-18 ${vectorClassName}`}
        alt="Vector"
        src={state.property1 === "variant-2" ? "/img/vector-1.png" : "/img/vector.png"}
      />
    </div>
  );
};

function reducer(state, action) {
  switch (action) {
    case "mouse_enter":
      return {
        ...state,
        property1: "variant-2",
      };

    case "mouse_leave":
      return {
        ...state,
        property1: "default",
      };
  }

  return state;
}

FreeTrialButton.propTypes = {
  property1: PropTypes.oneOf(["variant-2", "default"]),
};
